export { SlideOptions } from "#slide-options";
